import UserList from '@/views/User/List'
import UserAdd from '@/views/User/Add'
import UserEdit from '@/views/User/Edit'
import UserDetail from '@/views/User/Detail'

const user = [
  {
    path: 'users',
    name: 'UserList',
    component: UserList,
    meta: {
      roles: ['admin']
    }
  },
  {
    path: 'users/add',
    name: 'UserAdd',
    component: UserAdd,
    props: true
  },
  {
    path: 'users/:id/edit',
    name: 'UserEdit',
    component: UserEdit
  },
  {
    path: 'users/:id',
    name: 'UserDetail',
    component: UserDetail,
    props: true
  },
];

export default user;


// WEBPACK FOOTER //
// ./src/router/modules/user.js